/* global $:true */

import React from 'react';
import { withTooltip } from 'react-tippy';
import Utils from '../../js/utils.js';
import ProbeSelection from '../common/ProbeSelection.jsx';
import CategorySelection from '../common/CategorySelection.jsx';
import ModalWrapper from './modalWrapper.jsx';

/** *
 * PROPS
 * reloadConfig - [func] - fetch and reload config
 * slaveList - [obj] - {'AMS':'1.1.1.1', 'LON': '2.2.2.2', ...}
 * categories - [obj] - {'CAT1':{'CAT1_SUB':{I_P_S[...]},I_P_S:[{ip: "1.1.1.1", title: "one", isfav: false},..]}}
 */

class AddIpModal extends React.Component {
    constructor(props) {
        super(props);
        // Binding 'this scope' new in ES6
        this.successRedirect = this.successRedirect.bind(this);
        this.onInputChange = this.onInputChange.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.setProbesSelection = this.setProbesSelection.bind(this);
        this.getProbeSelection = this.getProbeSelection.bind(this);
        // Set state migrating from es5 by using previous getInitialState
        this.state = this.getInitialState();
    }

    getInitialState = () => ({
        inputIP: '',
        inputAlias: '',
        selectedProbes: [],
        selectedProbesReport: [],
        category: [],
        isFavChecked: false,
        tabSelection: 'probes',
        enableSaving: false,
        dontClose: false,
        ipv4Version: true,
    })

    changeClosingLogic = () => this.setState(prevState => ({ dontClose: !prevState.dontClose }));

    setCategory = data => this.setState({ category: data });

    changeFavourites = () => {
        const { isFavChecked } = this.state;
        this.setState({ isFavChecked: !isFavChecked });
    }

    successRedirect(dontClose = this.state.dontClose) {
        if (dontClose) {
            this.setState({
                inputIP: '',
                inputAlias: '',
                enableSaving: false,
                isFavChecked: false,
            });
        } else {
            this.props.reloadConfig(true);
            this.setState(this.getInitialState());
        }
    }

    /** *
     *  @param data - [obj] - {'probe1':false, 'probe2':true, 'probe3'; false...}
     *  @param keyState - key in local state
     *  output -> ['probe2'...]
     */
    setSelectedProbes = (data, keyState = 'selectedProbes') => {
        if (keyState === 'selectedProbes') {
            this.setState(prevState => ({ selectedProbesReport: prevState.selectedProbesReport.filter(probe => data[probe]) }));
        }
        this.setState({ [keyState]: Object.keys(data).filter(probe => data[probe]) });
    }

    /** *
     * @param data - [obj] - {{'probe1':'1.1.1.1', 'probe2':'2.2.2.2', 'probe3'; '3.3.3.3'}}
     * output -> {{'probe1':'false', 'probe2':'true', 'probe3'; 'false'}} - bool is decided on IP's probes in config
     */
    setProbesSelection(selectedProbes = this.state.selectedProbes) {
        const data = this.props.slaveList;
        // const data = JSON.parse('{"AMS-COGENT":false,"AMS-COREB":false,"AMS-DEFAULT":false,"AMS-GTT":false,"AMS-NTT":false,"AMS-ORANGE":false,"AMS-SPARKLE":false,"AMS-TELIA":false,"ATL-COGENT":false,"ATL-COMCAST":false,"ATL-DEFAULT":false,"ATL-NTT":false,"ATL-TELIA":false,"BGW-DEFAULT":false,"BOG-DEFAULT":false,"BRA-COGENT":false,"BRA-DEFAULT":false,"BRA-TELIA":false,"BUC-COGENT":false,"BUC-DEFAULT":false,"BUC-NTT":false,"BUC-ORANGE":false,"BUC-TELIA":false,"C-BUE":false,"C-LEA-AMS":false,"C-LEA-SGP":false,"C-LIM":false,"C-OVH-CA":false,"C-OVH-FR":false,"C-OVH-SGP":false,"C-SCA-PARIS":false,"C-SCL":false,"C-TELIA-LAX":false,"C-WS-AMS":false,"CHI-COGENT":false,"CHI-COMCAST":false,"CHI-DEFAULT":false,"CHI-GTT":false,"CHI-NTT":false,"CHI-TATA":false,"CHI-TELIA":false,"DAL-COGENT":false,"DAL-COMCAST":false,"DAL-DEFAULT":false,"DAL-GTT":false,"DAL-NTT":false,"DAL-SPARKLE":false,"DAL-TATA":false,"DAL-TELIA":false,"DEN-COGENT":false,"DEN-DEFAULT":false,"DEN-GTT":false,"DEN-TATA":false,"DEN-TELIA":false,"FRA-COGENT":false,"FRA-COREB":false,"FRA-DEFAULT":false,"FRA-GTT":false,"FRA-LEVEL3":false,"FRA-NTT":false,"FRA-ORANGE":false,"FRA-SPARKLE":false,"FRA-TELEFONICA":false,"FRA-TELIA":false,"HKG-COGENT":false,"HKG-DEFAULT":false,"HKG-NME":false,"HKG-NTT":false,"HKG-PCCW":false,"HKG-TATA":false,"HKG-TELIA":false,"HKG-VODAFONE":false,"IST-DEFAULT":false,"JAK-DEFAULT":false,"LAX-COGENT":false,"LAX-COMCAST":false,"LAX-DEFAULT":false,"LAX-NTT":false,"LAX-PCCW":false,"LAX-TATA":false,"LAX-TELIA":false,"LON-COGENT":false,"LON-COREB":false,"LON-DEFAULT":false,"LON-NTT":false,"LON-ORANGE":false,"LON-PCCW":false,"LON-SPARKLE":false,"LON-TELEFONICA":false,"LON-TELIA":false,"LON-UPC":false,"MAD-COGENT":false,"MAD-COREB":false,"MAD-DEFAULT":false,"MAD-LEVEL3":false,"MAD-NTT":false,"MAD-ORANGE":false,"MAD-TELEFONICA":false,"MAD-TELIA":false,"MIA-COGENT":false,"MIA-COMCAST":false,"MIA-DEFAULT":false,"MIA-GTT":false,"MIA-NTT":false,"MIA-SPARKLE":false,"MIA-TATA":false,"MIA-TELEFONICA":false,"MIA-TELIA":false,"MIL-COGENT":false,"MIL-DEFAULT":false,"MIL-SPARKLE":false,"MIL-TELIA":false,"MRS-COGENT":false,"MRS-DEFAULT":false,"MRS-SPARKLE":false,"MRS-TELIA":false,"NYC-COGENT":false,"NYC-COMCAST":false,"NYC-DEFAULT":false,"NYC-GTT":false,"NYC-NTT":false,"NYC-SPARKLE":false,"NYC-TATA":false,"NYC-TELEFONICA":false,"NYC-TELIA":false,"PAR-COGENT":false,"PAR-COREB":false,"PAR-DEFAULT":false,"PAR-NTT":false,"PAR-ORANGE":false,"PAR-SPARKLE":false,"PAR-TELIA":false,"PRG-10G-COGENT":false,"PRG-10G-COREB":false,"PRG-10G-DEFAULT":false,"PRG-10G-GTT":false,"PRG-10G-SPARKLE":false,"PRG-10G-TATA":false,"PRG-10G-TELIA":false,"PRG-10G-UPC":false,"PRG-10G-VODAFONE":false,"PRG-COGENT":false,"PRG-COREB":false,"PRG-CRA-ZIZ":false,"PRG-DEFAULT":false,"PRG-GTT":false,"PRG-ISPA":false,"PRG-M247":false,"PRG-ZC-VPN":false,"SAO-COGENT":false,"SAO-DEFAULT":false,"SAO-SPARKLE":false,"SAO-TELEFONICA":false,"SEA-COGENT":false,"SEA-COMCAST":false,"SEA-DEFAULT":false,"SEA-GTT":false,"SEA-TATA":false,"SEA-TELIA":false,"SGP-COGENT":false,"SGP-DEFAULT":false,"SGP-NTT":false,"SGP-PCCW":false,"SGP-SPARKLE":false,"SGP-TATA":false,"SGP-TELIA":false,"STO-COGENT":false,"STO-COREB":false,"STO-DEFAULT":false,"STO-GTT":false,"STO-TELIA":false,"SYD-COGENT":false,"SYD-COLOAU":false,"SYD-DEFAULT":false,"TYO-COGENT":false,"TYO-DEFAULT":false,"TYO-NTT":false,"TYO-PCCW":false,"TYO-TATA":false,"TYO-TELIA":false,"TYO-VODAFONE":false,"VIE-COGENT":false,"VIE-COREB":false,"VIE-DEFAULT":false,"VIE-NTT":false,"VIE-SPARKLE":false,"VIE-TELIA":false,"WAR-COGENT":false,"WAR-DEFAULT":false,"WAR-TELIA":false,"ZUR-COGENT":false,"ZUR-COREB":false,"ZUR-DEFAULT":false}');
        const outputFormat = {};
        const probeKeys = Object.keys(data);
        probeKeys.forEach((key) => {
            outputFormat[key] = selectedProbes.includes(key);
        });
        return outputFormat;
    }

    openModal = () => this.setState({ ...this.getInitialState() })

    saveChanges(e, confirmCallback) {
        e.preventDefault();
        const data = {};
        const ip = this.state.inputIP;
        data.desc = this.state.inputAlias;
        data.fav = this.state.isFavChecked;
        data.slaves = this.state.selectedProbes;
        let cat = Utils.isSet(this.state.category) ? this.state.category : [];
        cat = cat.length > 0 ? [cat.join('->') + '->'] : [''];
        if (this.state.selectedProbesReport.length > 0) {
            data.report = this.state.selectedProbesReport;
            cat.push('__Report->');
        }
        data.cat = cat;
        Utils.setConfigIp(data, ip, confirmCallback);
    }

    onInputChange(event) {
        const isIpv4 = this.state.ipv4Version;
        Utils.modals.onIpChange($('.input-ip'), isIpv4);
        let ip = event.target.value;
        ip = ip.toString().trim();
        const regex = Utils.getIpRegex(isIpv4);
        this.setState({
            inputIP: ip,
            enableSaving: regex.test(ip),
        });
    }

    onIpVersionChange(value) {
        this.setState((prev) => {
            const newVal = value || !prev.ipv4Version;
            return {
                inputIP: '',
                ipv4Version: newVal
            };
        });
    }

    getProbeSelection() {
        const { tabSelection } = this.state;
        const reportProps = {};
        if (tabSelection === 'report') {
            reportProps.title = 'Locations for Reporting';
            reportProps.setSelectedProbes = data => this.setSelectedProbes(data, 'selectedProbesReport');
            reportProps.probesList = this.setProbesSelection(this.state.selectedProbesReport);
            reportProps.allowed = this.state.selectedProbes;
            reportProps.tab = 'report';
        }
        const InfoIcon = () => (<i className='fa fa-info-circle' />);
        const tooltipOptions = {
            style: { marginLeft: '20px' },
            theme: 'dark',
            position: 'right',
            animation: 'perspective',
        };
        tooltipOptions.title = `Reporting behavior is customized to client's needs. 
                                Learn more at https://cocopacket.com/reporting.html`;
        const ReportTooltip = withTooltip(InfoIcon, tooltipOptions);
        return (
            <div className='slave-selection-with-tabs'>
                <ul>
                    <li
                        className={tabSelection === 'probes' ? 'active' : ''}
                        onClick={() => {
                            this.setState({ tabSelection: 'probes' });
                        }}
                    >
                        probes
                    </li>
                    <li
                        className={tabSelection === 'report' ? 'active' : ''}
                        onClick={() => {
                            this.setState({ tabSelection: 'report' });
                        }}
                    >
                        report
                        <ReportTooltip />
                    </li>
                </ul>
                <ProbeSelection
                    ke={tabSelection}
                    tab='monitoring'
                    inputIP={this.state.inputIP}
                    setSelectedProbes={this.setSelectedProbes}
                    probesList={this.setProbesSelection()}
                    ipVersion4={this.state.ipv4Version}
                    slaveSources={this.props.slaveSources}
                    {...reportProps}
                />
            </div>
        );
    }

    render() {
        const Trigger = ({ action }) => (
            <a onClick={action} className='add-ip'>
                <i className='fa fa-plus' />
                Add IP
            </a>
        );
        const styles = { content: { height: 'auto', width: '80%' } };
        const isIpv4 = this.state.ipv4Version;
        const renderComponent = confirmCallback => (
            <form id='add-new-ip-form' onSubmit={e => this.saveChanges(e, confirmCallback)}>
                <h2>Add IP address</h2>
                <div className='switch'>
                    <span className={isIpv4 ? 'active' : ''} onClick={() => this.onIpVersionChange(true)}>
                        IPv4
                    </span>
                    <label className='switch-slider'>
                        <input type='checkbox' onChange={() => this.onIpVersionChange()} checked={!isIpv4} />
                        <span className='slider round' />
                    </label>
                    <span className={isIpv4 ? '' : 'active'} onClick={() => this.onIpVersionChange(false)}>
                        IPv6
                    </span>
                </div>
                <span className='add-ip-address-box'>
                    <label className='label-title'>
                        <span>
                            IP ADDRESS
                            <i className='fa fa-star' />
                        </span>
                        <a className='favourite-selection inline' onClick={this.changeFavourites}>
                            <i className={'fa fa-star' + (this.state.isFavChecked ? '' : '-o')} />
                                Add to favourites
                        </a>
                    </label>
                    <input
                        type='text'
                        className='input-ip'
                        value={this.state.inputIP}
                        onChange={this.onInputChange}
                        placeholder={isIpv4 ? '8.8.8.8' : '2001:4860:4860::8888'}
                        required='required'
                        autoFocus
                    />
                </span>
                <span className='add-ip-alias-box'>
                    <label className='label-title'>
                        <span>IP ALIAS</span>
                    </label>
                    <input
                        type='text'
                        className='input-alias'
                        value={this.state.inputAlias}
                        onChange={e => this.setState({ inputAlias: e.target.value })}
                    />
                </span>
                <CategorySelection
                    catList={[]}
                    category={this.state.category}
                    setCategory={this.setCategory}
                    selectedIP={this.state.inputIP}
                    categories={this.props.categories}
                />
                {this.getProbeSelection()}
                <div className='butts'>
                    <label className='inp-check'>
                        <input type='checkbox' checked={this.state.dontClose} onChange={this.changeClosingLogic} />
                        <span>Don't close after adding</span>
                    </label>
                    <button
                        type='submit'
                        className='modal-confirm'
                        disabled={!this.state.enableSaving || this.state.selectedProbes.length == 0}
                    >
                        Save IP settings
                    </button>
                </div>
            </form>
        );
        return (
            <ModalWrapper
                Trigger={Trigger}
                style={styles}
                modalID='modal-add-ip'
                redirect={this.successRedirect}
                openModal={this.openModal}
                dontClose={this.state.dontClose}
                render={renderComponent}
                showRequiredInfo={true}
                customWrapClass='modalAddIp'
            />
        );
    }
}

export default AddIpModal;
